// src/components/EditCarRecipients.js
import React, { useState, useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { PickList } from "primereact/picklist";
import { Button } from "primereact/button";


const EditCarRecipients = ({ visible, onHide, currentRecipients, allRecipients, onSave }) => {
  const [source, setSource] = useState([]);
  const [target, setTarget] = useState([]);

  useEffect(() => {
    // Ustawiamy target jako aktualnie przypisanych odbiorców,
    // a source jako odbiorcy, którzy nie są przypisani.
    const targetIds = currentRecipients.map((r) => r.id);
    const newSource = allRecipients.filter((r) => !targetIds.includes(r.id));
    setSource(newSource);
    setTarget(currentRecipients);
  }, [currentRecipients, allRecipients]);

  const onChange = (event) => {
    setSource(event.source);
    setTarget(event.target);
  };

  const handleSave = () => {
    // Zapisujemy zmienioną listę – wywołujemy callback onSave z listą odbiorców target
    onSave(target);
    onHide();
  };

  const footer = (
    <div>
      <Button label="Zapisz" icon="pi pi-check" onClick={handleSave} />
      <Button label="Anuluj" icon="pi pi-times" onClick={onHide} className="p-button-secondary" />
    </div>
  );

  return (
    <Dialog header="Edytuj odbiorców" visible={visible} style={{ width: "50vw" }} footer={footer} onHide={onHide}>
      <PickList
        dataKey="id"
        source={source}
        target={target}
        showSourceControls={false}
        showTargetControls={false}
        itemTemplate={(item) => (
          <div className="flex align-items-center gap-2">
            <span>{item.nazwa}</span>
          </div>
        )}
        onChange={onChange}
        sourceHeader="Dostępni odbiorcy"
        targetHeader="Przypisani odbiorcy"
        filter
        filterBy="nazwa"
        breakpoint="800px"
        sourceStyle={{ height: "20rem" }}
        targetStyle={{ height: "20rem" }}
      />
    </Dialog>
  );
};

export default EditCarRecipients;
